import { cfgBaseCurrency, cfgBaseCurrencySymbol, stateTheme } from '@infinitro/config';
import { getBehaviorSubject, stateShowSidebarMobile, Theme } from '@infinitro/global';
import { of, timer } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { get, writable } from 'svelte/store';
const theme = get(stateTheme);
export const menuAutoCollapse = writable(false);
export const menuAutoCollapsed = writable(false);
export const languageIsExpanded = writable(false);
export const menuMobileOpen = writable(false);
// Sincronizar el estado de menuMobileOpen con stateShowSidebarMobile
stateShowSidebarMobile.subscribe((value) => {
    menuMobileOpen.set(value);
});
// jackpot
const jackpotDefaultValue = '0.00';
const jackpot$ = getBehaviorSubject(jackpotDefaultValue);
export const setFetchJackpotMEGA = () => {
    const setting = {
        type: 'mobile', // mobile, web
        currencyType: cfgBaseCurrency() ?? 'USD', // USD, JPY
        currency: {
            prefix: cfgBaseCurrencySymbol() ?? '$',
            suffix: '',
            grouping: ',',
            decimal: '.',
            precision: 1
        }
    };
    const url = `https://vip.fghjk.net/megajackpot/feed/jackpotdata?operator=FOMO&currency=${setting.currencyType}&hash=fa7ddaeec46e26bc37619008ca97f93f96a53f1c9c7514fd72f21a8343393025`;
    const intervalDuration = 30000;
    function getValueFormat(value) {
        const prefix = unicodeToChar(setting.currency.prefix);
        const suffix = unicodeToChar(setting.currency.suffix);
        const grouping = unicodeToChar(setting.currency.grouping);
        const decimal = unicodeToChar(setting.currency.decimal);
        return currencyFormatter(value, prefix, suffix, grouping, decimal, setting.currency.precision);
    }
    function currencyFormatter(number, prefix, suffix, grouping, decimal, precision) {
        const p2l = {
            1: 0,
            100: 2,
            100000: 5
        };
        const isNegative = number < 0;
        const internalNumber = Math.abs(number).toString().padStart(3, '0');
        const showKilo = precision === 100000 && internalNumber.length >= 6;
        const prec = showKilo ? p2l[precision] : 2;
        const str = internalNumber.substring(0, internalNumber.length - prec);
        const decimals = internalNumber.substr(internalNumber.length - prec, 2);
        let i = str.length;
        let result = '';
        while ((i -= 3) > 0) {
            result = `${grouping}${str.substr(i, 3)}${result}`;
        }
        return `${isNegative ? '-' : ''}${prefix}${str.substr(0, i + 3)}${result}${decimals === '00' ? '' : decimal + decimals}${showKilo ? 'k' : ''}${suffix}`;
    }
    function unicodeToChar(text) {
        return text.replace(/\\u([\dA-F]{4})/gi, (_, charCode) => String.fromCharCode(parseInt(charCode, 16)));
    }
    return of(true).pipe(switchMap(() => {
        if ([Theme.Fomo, Theme.Luna, Theme.Turboslots].includes(theme)) {
            return timer(0, intervalDuration).pipe(switchMap(() => fromFetch(url).pipe(switchMap((res) => res.json()))), tap((v) => {
                const vv = v?.jackpots?.MEGA_VALUE ?? 0;
                const formatVV = getValueFormat(vv);
                jackpot$.next(formatVV);
            }), catchError((e, caught) => {
                return caught.pipe(tap(() => jackpot$.next(jackpotDefaultValue)));
            }));
        }
        return of();
    }));
};
export const getJackpotMEGA = () => jackpot$.asObservable();
